/**
 * @author lifei
 * 功能：文件类型处理
 */
import { isString, isUndefined } from 'lodash-es'
import { Base } from '../base'

export class File2 extends Base {
  public constructor() {
    super()
  }

  static {
    Base.register(this)
  }

  /**
   * 功能：图片大小 MB
   */
  private imageMaxSize: number = 5

  /**
   * 功能：文件大小 MB
   */
  private fileMaxSize: number = 80

  /**
   * 功能：图片类型
   */
  private imageList = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tiff', 'tif']

  /**
   * 功能：文件类型列表
   */
  private fileList = ['doc', 'docx', 'pdf', 'zip', 'rar', 'ppt', 'pptx', 'xlsx', 'xls']

  /**
   * 功能：获取文件类型
   * 参数：file<File>
   * 返回值：string
   */
  public getType(file: File | string): TCommon.OrUndef<string> {
    if (isString(file)) {
      return file.split('.').pop()
    }
    return file.name.split('.').pop()
  }

  /**
   * 功能：获取图片大小
   * 参数：file<File>
   * 返回值：文件大小（Mb）
   */
  public getSize(file: File): number {
    const { size } = file
    const bit = 1024
    const val = size / bit / bit
    return Number(val.toFixed(2))
  }

  /**
   * 功能：文件是否为图片
   */
  public isImage(file: File): boolean {
    const fileType = this.getType(file)
    if (isUndefined(fileType)) {
      return false
    }
    return this.imageList.includes(fileType)
  }

  /**
   * 功能：检测是否为图片其他文件类型
   */
  public isFile(file: File): boolean {
    const fileType = this.getType(file)
    if (isUndefined(fileType)) {
      return false
    }
    return this.fileList.includes(fileType)
  }

  /**
   * 功能：校验文件类型
   */
  // public verifyType(file: File): boolean {
  //   const isImage = this.isImage(file)
  //   const isFile = this.isFile(file)
  //   return isImage || isFile
  // }

  /**
   * 功能：文件尺寸校验
   * 参数：file<File>
   * 返回值：boolean
   */
  public verifySize(file: File): boolean {
    const size = this.getSize(file)
    if (this.isImage(file)) {
      return size < this.imageMaxSize
    } else if (this.isFile(file)) {
      return size < this.fileMaxSize
    } else {
      return false
    }
  }

  /**
   * 功能：设置图片大小 MB
   * @param imageMaxSize
   */
  public setImageMaxSize = (imageMaxSize: number) => {
    this.imageMaxSize = imageMaxSize
  }

  /**
   * 功能：设置文件大小 MB
   * @param fileMaxSize
   */
  public setFileMaxSize = (fileMaxSize: number) => {
    this.fileMaxSize = fileMaxSize
  }

  /**
   * 功能：设置支持的图片列表
   * @param imageList 图片列表或以 "," 分割的字符串形式
   */
  public setImageList = (imageList: string[] | string) => {
    if (isString(imageList)) {
      imageList = imageList.split(/\s*,\s*/)
    }
    this.imageList = imageList
  }

  /**
   * 功能：设置支持的图片列表
   * @param imageList 图片列表或以 "," 分割的字符串形式
   */
  public setFileList = (fileList: string[] | string) => {
    if (isString(fileList)) {
      fileList = fileList.split(/\s*,\s*/)
    }
    this.fileList = fileList
  }

  /**
   * 功能：文件下载
   */
  public download = () => {}

  /**
   * 功能：文件预览
   */
  public preview = () => {}

  /**
   * 功能：压缩
   */
  public compress = () => {}
}

export const file2 = new File2()
